export default __webpack_public_path__ + "static/media/info.a5a68190.svg";